/**
@format
@flow
*/

type GraduationType = {
  month: number,
  year: number,
};

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const getGraduationInfo = (graduation: GraduationType): string => {
  const { month, year } = graduation || {};
  if (!month || !year) return '';

  const currentMonth: number = new Date().getMonth();
  const currentYear: number = new Date().getFullYear();
  const hasGraduated: boolean = currentYear > year
  || (currentYear >= year && currentMonth >= month);

  return `${hasGraduated ? 'Graduated' : 'Graduating'} ${
    months[parseInt(month, 10) - 1] || ''
  } ${year || ''}`;
};

export default getGraduationInfo;
